var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"big-switch",on:{"click":_vm.toggled}},[_c('div',{staticClass:"choice",class:{selected: !_vm.value}},[_vm._t("off")],2),_vm._v(" "),_c('div',{staticClass:"choice",class:{selected: _vm.value}},[_vm._t("on")],2),_vm._v(" "),_c('div',{staticClass:"selector",class:{right: _vm.value}})])
}
var staticRenderFns = []

export { render, staticRenderFns }